import React from "react";

import SectionWrapper from "../../components/common/SectionWrapper";
import Experience from "./Experience";
import Education from "./Education";
import Skills from "./Skills";

import resumeData from "../../data/resume.json";

function Resume() {
  return (
    <div className="resume-container container my-5">
      <header className="resume-header  mb-5">
        <h1 className="display-3">Resume</h1>
      </header>

      <SectionWrapper>
        <Experience experience={resumeData.workExperience} />
      </SectionWrapper>

      <SectionWrapper>
        <Education education={resumeData.education} />
      </SectionWrapper>

      <Skills skills={resumeData.skills} />
    </div>
  );
}

export default Resume;
